import axiosInstance from '../axiosInstance';
import { getManagerRoutePath } from '../managerRouteUtil';

/**
 * Rota > Available Shifts — /api/carehome-manager/open-shifts (care homes only).
 *
 * The home offers an extra shift; every carer FREE for it (day off, nothing
 * overlapping, not on leave, role matching) is told and can request it in the
 * app; the manager approves a request, which puts an ordinary scheduled shift
 * on that carer's rota. The API decides who is free — the page only shows it.
 *
 * Calls throw the raw axios error.
 */

const base = () => `/${getManagerRoutePath()}/open-shifts`;
const unwrap = (response) => response.data;

const openShiftsService = {
  // view: 'open' (still to happen) | 'history' (past + cancelled)
  list: async (view = 'open') => unwrap(await axiosInstance.get(base(), { params: { view } })),

  // { pending_requests, open_shifts } — the sidebar badge.
  summary: async () => unwrap(await axiosInstance.get(`${base()}/summary`)),

  // { groups: [{ id, name }], job_roles: [string] } — the offer form's lists.
  options: async () => unwrap(await axiosInstance.get(`${base()}/options`)),

  // How many carers are free for a shift being drafted.
  preview: async ({ date, start, end, job_role }) => unwrap(await axiosInstance.get(`${base()}/preview`, {
    params: { date, start, end, job_role: job_role || undefined },
  })),

  // { date, start, end, group_id, job_role, places, note, notify }
  create: async (body) => unwrap(await axiosInstance.post(base(), body)),

  cancel: async (id, reason) => unwrap(await axiosInstance.post(`${base()}/${id}/cancel`, { reason })),

  approve: async (requestId) => unwrap(await axiosInstance.post(`${base()}/requests/${requestId}/approve`)),

  decline: async (requestId, reason) => unwrap(await axiosInstance.post(`${base()}/requests/${requestId}/decline`, { reason })),
};

export default openShiftsService;
